<template>
    <div>
        <Snackbar
            v-if="showSnackbar"
            :snackbarColor="snackbarColor"
            :snackbarMessage="snackbarMessage"
            @close="closeSnackbar()"
        >
        </Snackbar>
        <v-layout class="notesLayout">
            <v-sheet
                class="notes"
                color="#fcfaf2"
                elevation="15"
                height='auto'
                width='300px'
            >
                <v-layout class="notes_title" overflow-hidden>
                    <b :title="notesInfo.tenant+ ' - Notes'">{{notesInfo.tenant}} - Notes</b>
                    <v-spacer></v-spacer>
                    <v-icon :color="showPencil ? '' : 'green'" :title="showPencil ? 'Edit' : 'Save'" @click="showPencil ? '' : updateNotes();showPencil = !showPencil;">{{ showPencil ? 'create' : 'done'}}</v-icon>
                    <v-icon color='red' :title="!showPencil ? 'Cancel' : 'Close'" @click="!showPencil ? cancelEdit() : $emit('close')">close</v-icon>
                </v-layout>
                <v-divider></v-divider>
                <v-layout class="lastEdit" overflow-hidden>
                    Last Edit by {{notesInfo.username}} at {{(notesInfo['timeStamp']).toLocaleTimeString()}} on {{(notesInfo['timeStamp']).toLocaleDateString()}}
                </v-layout>
                <v-divider></v-divider>
                <v-textarea
                    v-model="notes"
                    :background-color="showPencil? '#fcfaf2': '#faebd7'"
                    :readonly="showPencil"
                    no-resize
                    rows=22
                >
                </v-textarea>
            </v-sheet>
        </v-layout>
    </div>
</template>
<script>
import Vue from 'vue';
import Snackbar from "../../../common/components/snackbar"
import {hideLoadIcon,showLoadIcon} from '../../../common/assets/utils/load.js';
export default {
    name: 'NotesComponent',
    props:{
        notesInfo:{
            type: Object,
            default:{
                'tenant' : "",
                'schemaName' : "",
                'notes': "",
                'username':"",
                'timestamp': -1
            }
        },
    },
    data(){
        return{
            showPencil: true,
            timeEdited: new Date(),
            notes: this.notesInfo.notes,
            showSnackbar: false,
            snackbarColor: null,
            snackbarMessage: null,
            hide:null
        }
    },
    components: {
        Snackbar,
    },
    created() {
        this.getNotes();
    },
    methods:{
        getNotes(){
            var self = this;
            showLoadIcon();
            self.$loading(true);
            Vue.http.get('/notes/',{
                params:{
                    'schema_name' : self.notesInfo.schemaName
                }
            })
            .then((res) => {
                try{
                    let notesData = res.data['fields'];
                    self.notesInfo['notes'] = self.notes = notesData['note'];
                    self.notesInfo['username'] = notesData['username'];
                    self.notesInfo['timeStamp'] = new Date(notesData['last_updated_time']);
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }else{
                    self.displaySnackbar('error-banner',error.data.message);
                    self.$emit('close')
                }
            });
        },
        // createNotes(){
        //     var self = this,formData = new FormData();
        //     var notesData = {
        //         'schema_name' : self.notesInfo.schemaName,
        //         'username' : self.notesInfo.username,
        //         'note' : self.notesInfo.notes
        //     }
        //     formData.append('json', JSON.stringify(notesData));
        //     showLoadIcon();
        //     this.$loading(true);
        //     Vue.http.post('/notes/',formData)
        //     .then((res) => {
        //         try{
        //             self.snackbarColor = res.status == 201 ? 'error-banner' : 'success-banner'
        //         }
        //         catch(err){
        //             console.log("error is:",err);
        //         }
        //         finally{
        //             self.hide = hideLoadIcon();
        //             if(!self.hide){
        //                 this.$loading(false);
        //             }
        //         }
        //         self.displaySnackbar(self.snackbarColor,res.data.message);
		// 	}, (error) => {
        //         self.hide = hideLoadIcon();
        //         if(!self.hide){
        //             this.$loading(false);
        //         }
        //         self.displaySnackbar('error-banner',error.data.message);
        //         self.$emit('close')
		// 	})
        // },
        updateNotes(){
            var self = this,formData = new FormData();
            var notesData = {
                'schema_name': self.notesInfo.schemaName,
                'note': self.notes,
                'username': self.notesInfo.username,
            };
            showLoadIcon();
            this.$loading(true);
            Vue.http.put('/notes/', notesData)
            .then((res) => {
                try{
                    self.showPencil=true;
                    self.getNotes();
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
                self.displaySnackbar('success-banner',res.data.message);
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
        },
        cancelEdit(){
            var self = this;
            self.showPencil = true;
            self.notes= self.notesInfo.notes;
        },
        // Functions to display snackbar for success/error messages
        displaySnackbar(color,message){
            var self = this;
            self.showSnackbar = false;
            setTimeout(function(){
                self.showSnackbar = true;
            },100)
            self.snackbarColor = color;
            self.snackbarMessage = message;
        },
        closeSnackbar(){
            var self = this;
            self.showSnackbar = false;
            self.snackbarColor = null;
            self.snackbarMessage = null;
        },
        showLoadIcon,
        hideLoadIcon
    }
}
</script>

